module.exports = __webpack_public_path__ + "static/Sylvia-A-Alva-Signature-db012651a7d537e566d0f85bc0862448.svg";